// @flow

export const theme = {
  /*
   * The hex versions in comments are required for correctly matching to our
   * marvel prototypes. If they are wrong or the rgb values get changed, please
   * correct them.
   * The full list can be found here https://marvelapp.com/d1dgj8b/screen/62981019/handoff
   */
  palette: {
    blue10: "rgba(71, 166, 229, 0.1)",
    blue20: "rgba(71, 166, 229, 0.2)", // #DAEDFA
    blue40: "rgba(71, 166, 229, 0.4)", // #B5DBF5
    blue90: "rgba(71, 166, 229, 0.9)", // #59AEE7
    blue: "rgba(71, 166, 229, 1.0)", // #47A6E5
    blue150: "#2D89D9",
    hague10: "rgba(10, 66, 84, 0.1)", // #E6ECED
    hague20: "rgba(10, 66, 84, 0.2)", // #CED9DD
    hague30: "rgba(10, 66, 84, 0.3)", // #9DB3BB
    hague40: "rgba(10, 66, 84, 0.4)", // #9DB3BB
    hague50: "rgba(10, 66, 84, 0.5)", // #84A0A9
    hague70: "rgba(10, 66, 84, 0.7)", // #0A4254B3
    hague80: "rgba(10, 66, 84, 0.8)", // #3B6876
    hague90: "rgba(10, 66, 84, 0.9)", // #225465
    hague: "rgba(10, 66, 84, 1.0)", // #0A4254
    hague130: "rgba(7, 51, 67, 1)", // #073343
    pink20: "rgba(255, 212, 219, 0.2)", // #FFF6F8
    pink40: "rgba(255, 212, 219, 0.4)", // #FFEEF1
    pink: "rgba(255, 212, 219, 1.0)", // #FFD4DB
    pink500: "#FF92A1",
    sand20: "rgba(242, 235, 227, 0.2)", // #FCFBF9
    sand40: "rgba(242, 235, 227, 0.4)", // #FAF7F4
    sand80: "rgba(242, 235, 227, 0.8)", // #F5EFE9
    sand: "rgba(242, 235, 227, 1.0)", // #F2EBE3
    sand500: "#D9C7B3", // #D9C7B3
    terracotta20: "rgba(255, 135, 122, 0.2)", // #FF8770
    terracotta40: "rgba(255, 135, 122, 0.4)", // #FFCFC6
    terracotta60: "rgba(255, 135, 122, 0.6)", // #FFB7A9
    terracotta80: "rgba(255, 135, 122, 0.8)", // #FF9F8D
    terracotta90: "rgba(255, 135, 122, 0.9)", // #FF937E
    terracotta: "rgba(255, 135, 122, 1.0)", // #FF8770
    terracotta500: "#FE6A50",
    yellow20: "rgba(255, 194, 43, 0.2)", // #FFF3D5
    yellow40: "rgba(255, 194, 43, 0.4)", // #FFE7AA
    yellow80: "rgba(255, 194, 43, 0.8)", // #FFCE55
    yellow: "rgba(255, 194, 43, 1.0)", // #FFC22B
    yellow500: "#FFAB19",
    green: "rgba(61, 173, 144, 1.0)", // #3dad90"
    green80: "rgba(61, 173, 144, 0.8)", // #3cac90
    green60: "rgba(61, 173, 144, 0.6)", // #3cad8f
    green40: "rgba(61, 173, 144, 0.4)", // #3cac8e
    green20: "rgba(61, 173, 144, 0.2)", // #3caf91
    green500: "#3DAE91",
    warningOrange: "rgba(255, 231, 226)", // #ffe7e2
  },
  fonts: {
    euclid: "'Euclid Circular B', sans-serif",
    striverText: "StriverText, serif",
    handwritten: "'Reenie Beanie', cursive",
  },
  breakpoints: {
    tablet: 480,
    desktop: 860,
    maxDesktop: 1180,
  },
};
